var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 160,
    viewBox: "0 0 400 160",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 198.75 79.1)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.05 0)",
    id: "rect7406"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-325.65, -245)",
    d: "M 77.4 136.1 h 496.5 v 217.8 H 77.4 V 136.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 62.4 15.4)",
    id: "Trazado_16007"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-388, -260.4)",
    d: "M 388 224.8 c 3.4 -0.1 6.8 0.8 9.7 2.6 c 2.9 1.8 5.3 4.3 6.9 7.2 c 1.7 3.2 2.6 6.8 2.5 10.4 c 0.1 3.6 -0.8 7.2 -2.5 10.4 c -1.6 3 -4 5.5 -6.9 7.2 c -8.8 5.3 -20.3 2.5 -25.7 -6.3 c -0.2 -0.3 -0.3 -0.6 -0.5 -0.9 c -1.7 -3.2 -2.5 -6.8 -2.5 -10.4 c 0 -3.6 0.8 -7.2 2.5 -10.5 C 374.7 228.5 381.1 224.7 388 224.8 M 406.4 213.5 L 406.4 213.5 c -5.6 -3.2 -11.9 -4.8 -18.4 -4.8 c -12.9 -0.2 -24.9 6.7 -31.2 17.9 c -3.2 5.6 -4.8 12 -4.8 18.5 v 58.1 c -0.1 2.4 0.8 4.7 2.5 6.3 c 3.4 3.4 8.9 3.5 12.3 0.1 c 1.7 -1.7 2.7 -4.1 2.6 -6.5 v -29.3 c 5.9 4.9 13.3 7.5 20.9 7.4 c 6.1 0.1 12 -1.6 17.2 -4.7 c 5.2 -3.2 9.3 -7.7 12.1 -13.1 c 2.9 -5.7 4.4 -12 4.4 -18.4 c 0.1 -6.5 -1.5 -12.8 -4.7 -18.5 C 416.4 221.1 411.8 216.6 406.4 213.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 140.05 -0.03)",
    id: "Trazado_16008"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-465.65, -244.97)",
    d: "M 475.5 262.7 c -6.1 3.4 -13.5 3.4 -19.7 0 c -2.9 -1.7 -5.2 -4.2 -6.8 -7.1 c -1.7 -3.2 -2.5 -6.9 -2.5 -10.5 c -0.1 -3.7 0.8 -7.3 2.5 -10.6 c 1.6 -3 3.9 -5.4 6.8 -7.2 c 6.1 -3.4 13.5 -3.4 19.7 0 c 2.9 1.7 5.2 4.2 6.7 7.1 c 1.7 3.3 2.5 6.9 2.4 10.6 c 0.1 3.7 -0.8 7.3 -2.4 10.5 C 480.7 258.6 478.4 261 475.5 262.7 M 497.1 226.3 c -3 -5.4 -7.5 -9.9 -12.9 -13 c -5.6 -3.1 -12 -4.7 -18.5 -4.6 c -6.5 -0.1 -12.9 1.5 -18.6 4.6 c -5.4 3 -9.9 7.5 -12.9 12.9 c -3.1 5.8 -4.7 12.2 -4.6 18.8 c -0.1 6.5 1.5 12.9 4.6 18.6 c 3 5.4 7.5 9.9 12.9 13 c 11.6 6.2 25.6 6.2 37.2 0 c 5.4 -3 9.8 -7.5 12.8 -13 c 3.1 -5.7 4.7 -12.1 4.6 -18.6 C 501.8 238.5 500.2 232 497.1 226.3",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -97.2 0.12)",
    id: "Trazado_16009"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-228.4, -245.12)",
    d: "M 245.6 237.2 h -34.2 c 2.3 -8 9.9 -13.4 18.2 -12.8 c 4.2 -0.2 8.2 1.3 11.2 4.1 C 243.2 230.9 244.9 233.9 245.6 237.2 M 247.1 213.3 c -5.3 -3.1 -11.4 -4.7 -17.5 -4.5 c -6.4 -0.1 -12.7 1.5 -18.2 4.7 c -5.4 3.1 -9.7 7.6 -12.6 13 c -3 5.7 -4.6 12.2 -4.5 18.7 c -0.1 6.5 1.6 13 4.8 18.7 c 3.2 5.5 7.8 9.9 13.3 12.9 c 9.8 5.2 21.2 6.1 31.7 2.4 c 4 -1.3 7.7 -3.2 11 -5.7 c 1.9 -1.3 3 -3.4 3 -5.7 c 0 -2.4 -1.2 -4.6 -3.1 -6.1 c -1.5 -1.3 -3.4 -1.9 -5.3 -1.8 c -2 0 -4 0.6 -5.6 1.9 c -1.8 1.3 -3.7 2.2 -5.8 2.9 c -7.1 2.4 -14.9 1.1 -20.8 -3.4 c -3 -2.4 -5.1 -5.6 -6.2 -9.2 h 43 c 2.1 0.1 4.2 -0.7 5.8 -2.2 c 1.5 -1.5 2.4 -3.5 2.4 -5.7 c 0.1 -6.3 -1.2 -12.5 -3.9 -18.2 C 256 220.7 252.1 216.3 247.1 213.3",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -152.54 -10.89)",
    id: "Trazado_16012"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-173.06, -234.12)",
    d: "M 194.5 267 L 194.5 267 c -1.4 -1.6 -3.5 -2.6 -5.6 -2.6 h -4.1 c -1.8 0 -3.5 -0.9 -4.6 -2.3 c -1.5 -1.9 -2.2 -4.2 -2.1 -6.5 v -31.3 h 7.8 c 2.2 0.1 4.3 -0.7 5.9 -2.1 c 1.6 -1.4 2.4 -3.4 2.4 -5.5 c 0.1 -2.2 -0.8 -4.3 -2.4 -5.8 c -1.6 -1.4 -3.7 -2.2 -5.9 -2.1 h -7.8 v -18.1 c 0 -2 -1.6 -3.7 -3.7 -3.7 c -0.8 0 -1.5 0.2 -2.1 0.7 l -0.1 0 l -8.2 6.1 c -2 1.5 -3.2 3.8 -3.2 6.3 l 0 8.6 h -3 c -2.2 -0.1 -4.3 0.7 -5.9 2.1 c -1.6 1.5 -2.5 3.6 -2.4 5.8 c 0 2.1 0.8 4.1 2.4 5.5 c 1.6 1.4 3.7 2.2 5.9 2.1 h 3 v 31.3 c -0.1 4.6 1 9.1 3.1 13.2 c 2 3.9 5 7.1 8.6 9.4 c 3.7 2.2 8 3.3 12.2 3.1 h 2.2 c 2.4 0.2 4.9 -0.5 6.8 -1.9 c 1.9 -1.6 3 -3.9 2.9 -6.3 C 196.8 270.9 196 268.7 194.5 267",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.6 0)",
    id: "path1054"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,255,153)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-307, -245)",
    d: "M 285.6 233.2 l 37.9 45.1 c 1.2 1.5 3 2.4 4.9 2.7 v -26.2 l -37.9 -43.2 c -1.3 -1.4 -3 -2.4 -4.9 -2.6 L 285.6 233.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -48.85 0.07)",
    id: "path1056"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-276.75, -245.08)",
    d: "M 285.6 255.9 v -47 c -2.1 -0.3 -4.2 0.2 -5.9 1.5 l -8.4 6.2 c -2 1.5 -3.2 3.9 -3.2 6.4 l -0.1 32.9 h -0.1 v 16.4 c -0.1 2.4 0.8 4.7 2.6 6.4 c 3.4 3.5 9 3.5 12.4 0.1 c 1.8 -1.7 2.7 -4.1 2.6 -6.5 L 285.6 255.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.6 -0.18)",
    id: "path1058"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-337.2, -244.82)",
    d: "M 328.4 234 v 47 c 2.1 0.3 4.2 -0.2 5.9 -1.5 l 8.4 -6.2 c 2 -1.5 3.2 -3.9 3.2 -6.4 l 0.1 -32.9 h 0 v -16.4 c 0.1 -2.4 -0.8 -4.7 -2.6 -6.4 c -3.4 -3.5 -9 -3.5 -12.4 -0.1 c -1.8 1.7 -2.7 4.1 -2.6 6.5 L 328.4 234 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -37.6 -21.1)",
    id: "path1060"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-288, -223.9)",
    d: "M 290.4 238.9 l -4.8 -5.7 v -24.3 L 290.4 238.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.3 20.15)",
    id: "path1062"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-325.9, -265.15)",
    d: "M 323.5 249.3 l 4.8 5.5 V 281 L 323.5 249.3 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenpo);
export default __webpack_public_path__ + "static/media/tenpo.7444c152d36409fe656b7d77346f3add.svg";
export { ForwardRef as ReactComponent };